import {
  DEPART_AT_OPTION,
  ARRIVE_BY_OPTION,
  DEPART_NOW_OPTION,
} from '#/shared/constants';

/**
 * Return true if the itinerary happens 'now' (within numHours)
 * @param {Object} itinerary - Trip itinerary record from OTP
 * @param {Number} numHours - Window of time to query in hours
 * @returns {Boolean} Indication if this trip falls w/in time window
 */
export const itineraryIsCurrent = (itinerary, numHours = 2) => {
  let retVal = false;

  if (itinerary && itinerary.startTime && itinerary.endTime) {
    const now = Date.now();
    const hour = 1000 * 60 * 60;
    const nHours = hour * numHours;

    // trip starts and ends w/in N hours
    if (
      itinerary.startTime <= now + nHours &&
      itinerary.endTime >= now - nHours
    )
      retVal = true;
  }
  return retVal;
};

/**
 * Generate a series of consecutive number strings
 *
 * @param {Number} length Number items in the returned array
 * @param {Number} startingValue Value of first item in the array
 * @param {Number} paddedLength Minimum length of the strings that are returned;
 * if the digits in the number are less than this the string is front padded
 * with '0's
 * @returns {String[]}
 */
export const generateSequence = (length, startingValue = 0, paddedLength = 1) =>
  [...Array(length).keys()].map((v, ix) =>
    String(ix + startingValue).padStart(paddedLength, '0')
  );

/**
 * Get commonly needed information pertaining to the supplied departure option
 *
 * @param {String} departureOption Type of departure as defined in the string
 * constants used in this function
 * @returns {{departNow: boolean, arriveBy: boolean, departAt: boolean,
 * intlId: string }}
 */
export const getDepartureOptionData = departureOption => ({
  arriveBy: departureOption === ARRIVE_BY_OPTION,
  departAt: departureOption === DEPART_AT_OPTION,
  departNow: departureOption === DEPART_NOW_OPTION,
  intlId: `planner.${
    {
      [DEPART_AT_OPTION]: 'depart_at',
      [ARRIVE_BY_OPTION]: 'arrive_by',
      [DEPART_NOW_OPTION]: 'depart_now',
    }[departureOption]
  }`,
});
